<template>
  <div class="survey-page">
    <!-- ===== Success Popup ===== -->
    <van-popup
      v-model:show="showSuccess"
      round
      :close-on-click-overlay="false"
      position="center"
      :style="{ width: '88%', maxWidth: '420px' }"
    >
      <div class="success-content">
        <van-icon name="checked" size="56" color="#07c160" class="success-icon" />
        <h2>提交成功</h2>
        <p class="success-desc">感谢您的参与，祝您早日康复！</p>
        <!-- <div class="json-preview">{{ submitJson }}</div> -->
        <div class="success-btns">
          <van-button block plain @click="onClickLeft">返回上级</van-button>
          <van-button block type="primary" @click="resetForm">再次填写</van-button>
        </div>
      </div>
    </van-popup>

    <!-- ===== NavBar ===== -->
    <van-nav-bar title="患者满意度调查" fixed placeholder  @click-left="onClickLeft">
    <template #left>
        <van-icon name="arrow-left" /> 返回
      </template>
    </van-nav-bar>

    <!-- ===== Intro ===== -->
    <div class="intro-card">
      <p><strong>尊敬的患者（家属）朋友：</strong></p>
      <p>
        您好！感谢您对我院的信任与支持。为进一步提升医疗服务质量，恳请您结合本次就诊/住院的真实感受填写此问卷。本调查采取匿名方式，所有信息仅用于改进工作，我们将严格保密。感谢您的配合！
      </p>
    </div>

    <!-- ===== Form ===== -->
    <van-form @submit="onSubmit" class="survey-form">
      <!-- Section 1: Basic Info -->
      <van-cell-group inset title="一、基本信息">
        <van-field name="VisitType" label="就诊类型" required
          :rules="[{ required: true, message: '请选择就诊类型' }]">
          <template #input>
            <van-radio-group v-model="form.VisitType" direction="horizontal">
              <van-radio v-for="opt in visitTypeOptions" :key="opt.value" :name="opt.value">
                {{ opt.label }}
              </van-radio>
            </van-radio-group>
          </template>
        </van-field>

        <van-field v-model="form.Department" label="就诊科室" placeholder="请输入科室名称" />

        <van-field name="Gender" label="性别" required
          :rules="[{ required: true, message: '请选择性别' }]">
          <template #input>
            <van-radio-group v-model="form.Gender" direction="horizontal">
              <van-radio v-for="opt in genderOptions" :key="opt.value" :name="opt.value">
                {{ opt.label }}
              </van-radio>
            </van-radio-group>
          </template>
        </van-field>

        <van-field name="AgeGroup" label="年龄" required
          :rules="[{ required: true, message: '请选择年龄段' }]">
          <template #input>
            <van-radio-group v-model="form.AgeGroup" direction="horizontal" class="wrap-group">
              <van-radio v-for="opt in ageGroupOptions" :key="opt.value" :name="opt.value">
                {{ opt.label }}
              </van-radio>
            </van-radio-group>
          </template>
        </van-field>

        <van-field name="Education" label="文化程度" required
          :rules="[{ required: true, message: '请选择文化程度' }]">
          <template #input>
            <van-radio-group v-model="form.Education" direction="horizontal" class="wrap-group">
              <van-radio v-for="opt in educationOptions" :key="opt.value" :name="opt.value">
                {{ opt.label }}
              </van-radio>
            </van-radio-group>
          </template>
        </van-field>
      </van-cell-group>

      <!-- Rating Sections (2 ~ 6) -->
      <van-cell-group
        v-for="section in ratingSections"
        :key="section.title"
        inset
        :title="section.title"
      >
        <div v-if="section.subtitle" class="section-subtitle">{{ section.subtitle }}</div>

        <div
          v-for="item in getVisibleItems(section.items)"
          :key="item.key"
          class="rating-cell"
        >
          <div class="rating-label">
            <span>{{ item.label }}</span>
            <van-tag v-if="item.inpatientOnly" type="primary" size="mini" class="inpatient-tag">住院</van-tag>
          </div>
          <van-radio-group
            v-model="form[item.key]"
            direction="horizontal"
            class="rating-group"
          >
            <van-radio
              v-for="opt in getOptions(item)"
              :key="opt.value"
              :name="opt.value"
              :class="['rating-radio', 'val-' + opt.value, { 'is-checked': form[item.key] === opt.value }]"
            >
              {{ opt.label }}
            </van-radio>
          </van-radio-group>
        </div>
      </van-cell-group>

      <!-- Section 7: Open Questions -->
      <van-cell-group inset title="七、开放性问题（选填）">
        <van-field
          v-model="form.FavoriteStaff"
          label="最满意医护"
          placeholder="医生/护士姓名"
        />
        <van-field
          v-model="form.ImprovementSuggestion"
          type="textarea"
          label="改进建议"
          placeholder="最需要改进的方面"
          rows="2"
          autosize
        />
        <van-field
          v-model="form.AdditionalFeedback"
          type="textarea"
          label="其他建议"
          placeholder="其他意见或建议"
          rows="2"
          autosize
        />
        <van-field name="Recommend" label="是否推荐">
          <template #input>
            <van-radio-group v-model="form.Recommend" direction="horizontal" class="wrap-group">
              <van-radio v-for="opt in recommendOptions" :key="opt.value" :name="opt.value">
                {{ opt.label }}
              </van-radio>
            </van-radio-group>
          </template>
        </van-field>
      </van-cell-group>

      <!-- Footer -->
      <div class="footer-text">再次感谢您的参与！祝您早日康复！</div>

      <!-- Submit Bar -->
      <div class="submit-bar">
        <div class="progress-text">已完成 {{ answeredCount }} / {{ totalQuestions }} 题</div>

  
        <van-button
          block
          type="primary"
          native-type="submit"
          :loading="submitting"
          loading-text="提交中..."
        >
          提交问卷
        </van-button>
      </div>
    </van-form>
 
  </div>
</template>

<script setup>
import { ref, reactive, computed, watch } from 'vue';
import { showToast,showFailToast } from 'vant';
import { postJson } from '@/api/axiosInstance'
import { useopenidStore } from '@/stores'

// ===== Options =====
const ratingOptions = [
  { value: 5, label: '非常满意' },
  { value: 4, label: '满意' },
  { value: 3, label: '一般' },
  { value: 2, label: '不满意' },
  { value: 1, label: '非常不满意' },
];

const visitTypeOptions = [
  { value: 1, label: '门诊' },
  { value: 2, label: '住院' },
];

const genderOptions = [
  { value: 1, label: '男' },
  { value: 2, label: '女' },
];

const ageGroupOptions = [
  { value: 1, label: '18岁以下' },
  { value: 2, label: '18-30岁' },
  { value: 3, label: '31-45岁' },
  { value: 4, label: '46-60岁' },
  { value: 5, label: '60岁以上' },
];

const educationOptions = [
  { value: 1, label: '初中及以下' },
  { value: 2, label: '高中/中专' },
  { value: 3, label: '大专/本科' },
  { value: 4, label: '研究生及以上' },
];

const integrityOptions = [
  { value: 1, label: '是' },
  { value: 2, label: '否' },
  { value: 3, label: '不清楚' },
];

const recommendOptions = [
  { value: 1, label: '一定会' },
  { value: 2, label: '可能会' },
  { value: 3, label: '可能不会' },
  { value: 4, label: '一定不会' },
];

// ===== Rating sections (2 ~ 6) =====
const ratingSections = [
  {
    title: '二、对医院整体的评价',
    subtitle: '请根据您的真实感受，选择最符合的选项',
    items: [
      { key: 'OverallImpression', label: '您对医院的总体印象', type: 'rating' },
      { key: 'ProcessConvenience', label: '医院的就诊流程是否合理便捷', type: 'rating' },
      { key: 'SignageClarity', label: '医院内的路标和指示是否清晰明确', type: 'rating' },
      { key: 'EnvironmentCleanliness', label: '医院的环境卫生（含病房/诊室、卫生间等）', type: 'rating' },
      { key: 'FacilityCondition', label: '医院的设施条件（座椅、电梯、饮水等）', type: 'rating' },
      { key: 'PrivacyRespect', label: '医院对患者隐私的尊重与保护', type: 'rating' },
      { key: 'ChargeReasonableness', label: '医院的收费是否合理、费用清单是否清晰', type: 'rating' },
    ],
  },
  {
    title: '三、对科室的评价',
    subtitle: '',
    items: [
      { key: 'DeptOverall', label: '您对所在科室的总体评价', type: 'rating' },
      { key: 'DeptOrderManagement', label: '科室的秩序与管理', type: 'rating' },
      {
        key: 'DeptIntegrity',
        label: '科室医护人员是否做到廉洁行医（无收受红包、吃请等）',
        type: 'choice',
        options: integrityOptions,
      },
    ],
  },
  {
    title: '四、对医生的评价',
    subtitle: '请对医生的服务进行评价',
    items: [
      { key: 'DocAttitude', label: '医生的服务态度', type: 'rating' },
      { key: 'DocSkill', label: '医生的医疗技术水平', type: 'rating' },
      { key: 'DocCarefulness', label: '医生查房/接诊时认真查看病情', type: 'rating' },
      { key: 'DocExplanation', label: '医生耐心解答您的疑问', type: 'rating' },
      { key: 'DocUnderstandable', label: '医生用您听得懂的方式解释病情和治疗方案', type: 'rating' },
      { key: 'DocInformedConsent', label: '治疗/用药前，医生告知相关事项和费用', type: 'rating' },
      { key: 'DocRespectOpinion', label: '医生尊重并征求您对治疗方案的意见', type: 'rating' },
    ],
  },
  {
    title: '五、对护士的评价',
    subtitle: '请对护士的服务进行评价',
    items: [
      { key: 'NurseAttitude', label: '护士的服务态度', type: 'rating' },
      { key: 'NurseSkill', label: '护士的技术操作水平', type: 'rating' },
      { key: 'NurseAdmissionIntro', label: '入院时护士主动介绍病房环境及注意事项', type: 'rating', inpatientOnly: true },
      { key: 'NurseCommunication', label: '护士主动与您沟通病情、进行健康指导', type: 'rating' },
      { key: 'NurseCallResponse', label: '按呼叫铃后护士能及时回应和帮助', type: 'rating' },
      { key: 'NurseRounds', label: '护士定时巡视病房', type: 'rating', inpatientOnly: true },
      { key: 'NurseMedicationGuidance', label: '护士耐心指导正确用药', type: 'rating' },
      { key: 'NurseDischargeGuidance', label: '出院时护士告知康复、用药及复查注意事项', type: 'rating' },
    ],
  },
  {
    title: '六、对其他服务的评价',
    subtitle: '请对以下服务进行评价',
    items: [
      { key: 'ServiceBilling', label: '挂号/收费/出入院手续办理服务', type: 'rating' },
      { key: 'ServicePharmacy', label: '药房工作人员服务', type: 'rating' },
      { key: 'ServiceAuxiliary', label: '医技科室（检验/影像/B超等）服务', type: 'rating' },
      { key: 'ServiceCatering', label: '医院餐饮服务', type: 'rating' },
      { key: 'ServiceLogistics', label: '保安、保洁等后勤服务', type: 'rating' },
    ],
  },
];

// ===== Form data (matches SQL table wxgzh_myddy) =====
const form = reactive({
  OpenID: '',
  // Section 1
  VisitType: null,       // 1-门诊, 2-住院
  Department: '',        // 科室名称
  Gender: null,          // 1-男, 2-女
  AgeGroup: null,        // 1-5
  Education: null,       // 1-4
  // Section 2
  OverallImpression: null,
  ProcessConvenience: null,
  SignageClarity: null,
  EnvironmentCleanliness: null,
  FacilityCondition: null,
  PrivacyRespect: null,
  ChargeReasonableness: null,
  // Section 3
  DeptOverall: null,
  DeptOrderManagement: null,
  DeptIntegrity: null,   // 1-是, 2-否, 3-不清楚
  // Section 4
  DocAttitude: null,
  DocSkill: null,
  DocCarefulness: null,
  DocExplanation: null,
  DocUnderstandable: null,
  DocInformedConsent: null,
  DocRespectOpinion: null,
  // Section 5
  NurseAttitude: null,
  NurseSkill: null,
  NurseAdmissionIntro: null,
  NurseCommunication: null,
  NurseCallResponse: null,
  NurseRounds: null,
  NurseMedicationGuidance: null,
  NurseDischargeGuidance: null,
  // Section 6
  ServiceBilling: null,
  ServicePharmacy: null,
  ServiceAuxiliary: null,
  ServiceCatering: null,
  ServiceLogistics: null,
  // Section 7
  FavoriteStaff: '',
  ImprovementSuggestion: '',
  AdditionalFeedback: '',
  Recommend: null,       // 1-一定会, 2-可能会, 3-可能不会, 4-一定不会
});

// ===== State =====
const showSuccess = ref(false);
const submitting = ref(false);
const submitJson = ref('');

// ===== Watch: clear inpatient-only fields when switching to outpatient =====
watch(
  () => form.VisitType,
  (newVal) => {
    if (newVal === 1) {
      form.NurseAdmissionIntro = null;
      form.NurseRounds = null;
    }
  },
);

const onClickLeft = () => history.back();

// ===== Helpers =====
const getVisibleItems = (items) => {
  if (form.VisitType === 1) {
    return items.filter((item) => !item.inpatientOnly);
  }
  return items;
};

const getOptions = (item) => {
  return item.type === 'choice' ? item.options : ratingOptions;
};

// ===== Computed: progress =====
const totalQuestions = computed(() => {
  let count = 5; // Section 1: VisitType, Department, Gender, AgeGroup, Education
  ratingSections.forEach((section) => {
    count += getVisibleItems(section.items).length;
  });
  count += 4; // Section 7: 3 text + 1 recommend
  return count;
});

const answeredCount = computed(() => {
  let count = 0;
  if (form.VisitType) count++;
  if (form.Department) count++;
  if (form.Gender) count++;
  if (form.AgeGroup) count++;
  if (form.Education) count++;

  ratingSections.forEach((section) => {
    getVisibleItems(section.items).forEach((item) => {
      if (form[item.key] !== null && form[item.key] !== '') count++;
    });
  });

  if (form.FavoriteStaff) count++;
  if (form.ImprovementSuggestion) count++;
  if (form.AdditionalFeedback) count++;
  if (form.Recommend !== null) count++;

  return count;
});

// ===== Form handlers =====
const onFailed = (errorInfo) => {
  if (errorInfo.errors && errorInfo.errors.length > 0) {
    showToast(errorInfo.errors[0].message);
  }
};

const onSubmit = async () => {

  // Build payload: only include non-null, non-empty values
  const payload = {};
  Object.keys(form).forEach((key) => {
    const val = form[key];
    if (val !== null && val !== '') {
      payload[key] = val;
    }
  });
  payload['lx']='myddy'
  payload['OpenID']=useopenidStore().data.openid
  let params=JSON.stringify(payload);
  
  console.log("满意度调查入参："+params)
  
  // postJson('Wechat/Service', params, 0).then(res => {
  //       if (res.data.ret != 0) {            
  //           showFailToast(res.data.reinfo);
  //           return        
  //     }
  //   })
  // ---- Submit to backend API (uncomment in production) ----
   try {
     const res = await fetch('https:///wxgzh.cxxjw.cn/Wechat/Service', {
       method: 'POST',
       headers: { 'Content-Type': 'application/json' },
       body: JSON.stringify(payload),
     });
     const result = await res.json();
     console.log("出参："+JSON.stringify(result));
     if (result.data.ret !== 0) throw new Error(result.data.reinfo);
   } catch (e) {
     showToast('提交失败：' + e.message);
     submitting.value = false;
     return;
   }

  // Simulate network delay
  await new Promise((resolve) => setTimeout(resolve, 800));

  submitJson.value = JSON.stringify(payload, null, 2);
  showSuccess.value = true;
  submitting.value = false;
  window.scrollTo({ top: 0, behavior: 'smooth' });
};

// ===== Copy JSON =====
const copyJson = () => {
  if (navigator.clipboard) {
    navigator.clipboard.writeText(submitJson.value).then(() => {
      showToast('JSON 已复制到剪贴板');
    });
  } else {
    const ta = document.createElement('textarea');
    ta.value = submitJson.value;
    document.body.appendChild(ta);
    ta.select();
    document.execCommand('copy');
    document.body.removeChild(ta);
    showToast('JSON 已复制到剪贴板');
  }
};

// ===== Reset =====
const resetForm = () => {
  Object.keys(form).forEach((key) => {
    form[key] = typeof form[key] === 'string' ? '' : null;
  });
  showSuccess.value = false;
  submitJson.value = '';
  window.scrollTo({ top: 0, behavior: 'smooth' });
};
</script>

<style>
/* Non-scoped: Vant theme override */
:root {
  --van-primary-color: #1a7a8e;
}
</style>

<style scoped>
.survey-page {
  min-height: 100vh;
  background: #f7f8fa;
  padding-bottom: 100px;
}

/* ===== Intro Card ===== */
.intro-card {
  margin: 12px;
  padding: 20px 18px;
  background: linear-gradient(135deg, #1a7a8e 0%, #2ba8c2 100%);
  border-radius: 12px;
  color: #fff;
  font-size: 13.5px;
  line-height: 1.85;
  box-shadow: 0 4px 16px rgba(26, 122, 142, 0.25);
}
.intro-card p {
  margin-bottom: 8px;
}
.intro-card p:last-child {
  margin-bottom: 0;
}
.intro-card strong {
  font-weight: 600;
}

/* ===== Section Subtitle ===== */
.section-subtitle {
  padding: 8px 16px 4px;
  font-size: 12px;
  color: #969799;
}

/* ===== Rating Cell ===== */
.rating-cell {
  padding: 12px 16px;
  border-bottom: 1px solid #f2f3f5;
}
.rating-cell:last-child {
  border-bottom: none;
}

.rating-label {
  font-size: 14px;
  color: #323233;
  font-weight: 500;
  margin-bottom: 8px;
  display: flex;
  align-items: flex-start;
  gap: 6px;
  line-height: 1.5;
}

.inpatient-tag {
  flex-shrink: 0;
}

/* ===== Rating Group - Pill Style ===== */
.rating-group {
  display: flex !important;
  flex-wrap: wrap;
  gap: 8px;
}

.rating-group :deep(.van-radio) {
  display: inline-flex;
  align-items: center;
  padding: 5px 13px;
  border: 1.5px solid #e4e7ea;
  border-radius: 16px;
  background: #fafbfc;
  font-size: 13px;
  color: #646566;
  transition: all 0.2s ease;
  margin: 0;
  height: auto;
  line-height: 1.5;
}

.rating-group :deep(.van-radio__icon) {
  display: none !important;
}

.rating-group :deep(.van-radio__label) {
  margin-left: 0;
  line-height: 1.5;
}

/* Checked state - color coded */
.rating-group :deep(.van-radio.is-checked) {
  color: #fff;
  font-weight: 600;
  border-color: transparent;
  transform: scale(1.03);
}
.rating-group :deep(.van-radio.is-checked.val-5) {
  background: #27ae60;
}
.rating-group :deep(.van-radio.is-checked.val-4) {
  background: #52c41a;
}
.rating-group :deep(.van-radio.is-checked.val-3) {
  background: #f39c12;
}
.rating-group :deep(.van-radio.is-checked.val-2) {
  background: #e67e22;
}
.rating-group :deep(.van-radio.is-checked.val-1) {
  background: #e74c3c;
}

/* ===== Wrap Group (for basic info radios that need wrapping) ===== */
.wrap-group {
  display: flex !important;
  flex-wrap: wrap;
  gap: 8px;
}
.wrap-group :deep(.van-radio) {
  margin-right: 0;
}

/* ===== Submit Bar ===== */
.submit-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  padding: 10px 16px 16px;
  box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.08);
  z-index: 100;
}

.progress-text {
  text-align: center;
  font-size: 12px;
  color: #969799;
  margin-bottom: 8px;
}

/* ===== Footer ===== */
.footer-text {
  text-align: center;
  font-size: 13px;
  color: #969799;
  padding: 16px 0 8px;
}

/* ===== Success Popup ===== */
.success-content {
  padding: 32px 24px 24px;
  text-align: center;
}

.success-content h2 {
  font-size: 20px;
  margin: 12px 0 8px;
}

.success-desc {
  font-size: 14px;
  color: #646566;
  margin-bottom: 16px;
}

.json-preview {
  background: #1e1e2e;
  color: #cdd6f4;
  padding: 14px;
  border-radius: 8px;
  text-align: left;
  margin: 12px 0 16px;
  max-height: 260px;
  overflow: auto;
  font-size: 12px;
  font-family: 'Consolas', 'Monaco', 'Courier New', monospace;
  line-height: 1.6;
  white-space: pre-wrap;
  word-break: break-all;
}

.success-btns {
  display: flex;
  gap: 8px;
}
</style>
